<!-- Tab "Skills" of /agent-setup — the host owns header and card. -->
<app-table
  rowIdKey="id"
  [nbSpinner]="isLoading"
  [title]="''"
  [columns]="columns"
  [data]="rows"
  [rowActions]="rowActions"
  [globalActions]="globalActions"
  [maxVisibleItems]="25"
  (event)="onTableEvent($event)"
></app-table>
